import { useState, useEffect } from 'react'
import { getAge } from './validateAge'
import { addDataLayer } from './dataLayer'
import axios from 'axios'
require('dotenv').config()

let documentExist
let documentExistQtd = 0

let wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const useForm = (callback, validate, validateStep1) => {
  const [values, setValues] = useState({})
  const [errors, setErrors] = useState({})
  const [errorsStep1, setErrorsStep1] = useState({})
  const [step, setStep] = useState(1)
  const [confirmation, setConfirmation] = useState(false)
  const [loading, setLoading] = useState(false)
  const [ipUser, setIP] = useState()
  const [dateRegister, setDateRegister] = useState()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [links, setLinks] = useState([])

  const [checked1, setChecked1] = useState(false)
  const [checked2, setChecked2] = useState(false)
  const [checked3, setChecked3] = useState(false)

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback()
    }

    //loadLinks();
    getUserIp()
    getDate()
  }, [errors, callback, isSubmitting])

  const loadLinks = async () => {
    if (links && links.length === 0) {
      const res = await fetch('/.netlify/functions/getLinks')
      const result = await res.json()
      setLinks(result)
    } else {
      let newArray = links.filter(function (el) {
        return el.documentNumber === values.documentNumber
      })
      documentExist = newArray
      documentExistQtd = documentExist.length
    }
  }

  const handleStep = async (e, idStep) => {
    if (e) e.preventDefault()
    if (idStep === 1) {
      setErrors(validate(values))
    } else {
      setErrorsStep1(validateStep1(values))
    }

    let valueQty = Object.keys(values).length >= 6
    let documentNumber = values && values.documentNumber ? values.documentNumber : ''
    let regexValidEmail = /^([\w-\.]+@([\w-]+\.)+(com|com.co|es|co))?$/
    const validEmail = regexValidEmail.test(values.email)

    let regexValidName = /\d/
    const validNombre = regexValidName.test(values.name)
    const validApelido = regexValidName.test(values.apelido)

    let documentNombre = values && values.name ? values.name : ''
    let documentApelido = values && values.apelido ? values.apelido : ''

    if (
      values.documentType === '1' &&
      valueQty === true &&
      getAge(values.date) >= 18 &&
      documentNumber.length >= 6 &&
      documentNumber.length <= 10 &&
      !/[-!$%^&*()_+|~=`\\#{}\[\]:";'<>?,.\/]/.test(values.documentNumber) &&
      values.email !== '' &&
      /^([a-z]){1,}([a-z0-9._-]){1,}([@]){1}([a-z]){2,}([.]){1}([a-z]){2,}([.]?){1}([a-z]?){2,}$/i.test(
        values.email
      ) &&
      validEmail === true &&
      validNombre === false &&
      validApelido === false &&
      !documentNombre.length < 1 &&
      !documentApelido.length < 1
    ) {
      setStep(idStep)
    } else if (
      values.documentType === '2' &&
      valueQty === true &&
      getAge(values.date) >= 18 &&
      documentNumber.length >= 6 &&
      documentNumber.length <= 7 &&
      !/[-!$%^&*()_+|~=`\\#{}\[\]:";'<>?,.\/]/.test(values.documentNumber) &&
      values.email !== '' &&
      /^([a-z]){1,}([a-z0-9._-]){1,}([@]){1}([a-z]){2,}([.]){1}([a-z]){2,}([.]?){1}([a-z]?){2,}$/i.test(
        values.email
      ) &&
      validEmail === true &&
      validNombre === false &&
      validApelido === false &&
      !documentNombre.length < 1 &&
      !documentApelido.length < 1
    ) {
      setStep(idStep)
    }
  }

  const handleStepReturn = async (e) => {
    if (e) e.preventDefault()
    setStep(1)
  }

  const handleSubmit = async (event) => {
    if (event) event.preventDefault()
    getUserIp()
    setErrors(validate(values))

    let valueQty = Object.keys(values).length >= 12

    let dateString = values && values.date ? values.date : ''
    let finalDateString = dateString.split(/[-]+/)

    let _celular = values && values.celular ? values.celular : ''
    let _direccion = values && values.direccion ? values.direccion : ''
    let _complemento = values && values.complemento ? values.complemento : ''
    let _localNumber = values && values.localNumber ? values.localNumber : ''

    if (
      valueQty === true &&
      _celular.length === 10 &&
      values.documentNumber !== _celular &&
      _complemento.length > 0 &&
      _direccion.length > 0 &&
      _localNumber.length > 0
    ) {
      setIsSubmitting(true)
      setLoading(true)

      const bodyFauna = {
        UUID: '',
        name: values.name,
        apelido: values.apelido,
        date: finalDateString[2] + '/' + finalDateString[1] + '/' + finalDateString[0],
        documentType: values.documentType,
        email: values.email,
        documentNumber: values.documentNumber,
        ciudad: values.ciudad.label,
        codigo_mun_tu: values.ciudad.codigo_mun_tu,
        codigo_gera: values.ciudad.codigo_gera,
        codigo_dept_tu: values.ciudad.codigo_dept_tu,
        celular: values.celular,
        direccion: values.direccion,
        complemento: values.complemento,
        localNumber: values.localNumber,
        localType: values.localType ? values.localType : '',
        dateRegister: dateRegister,
        idReferencia: values.idReferencia ? values.idReferencia : '',
        statusEquifax: true,
        acceptTerm: true,
        ipUser: ipUser,
        UTMsource: values.UTMsource ? values.UTMsource : '',
        UTMmedium: values.UTMmedium ? values.UTMmedium : '',
        UTMcampaign: values.UTMcampaign ? values.UTMcampaign : '',
        UTMterm: values.UTMterm ? values.UTMterm : '',
        UTMcontent: values.UTMcontent ? values.UTMcontent : '',
        URLorigin: values.URLorigin ? values.URLorigin : '',
        log: ''
      }

      try {
        const response = await axios.post('/.netlify/functions/createRegister', bodyFauna)

        setLoading(false)
        setConfirmation(true)
        addDataLayer(response.data, 'Success')
        setStep(1)
        setValues({
          token: values.token,
          ipUser: ipUser
        })
        setChecked1(false)
        setChecked2(false)
        setChecked3(false)
        setErrors({})

        const createdUser = response.data

        const body = {
          token: values.token,
          name: createdUser.name,
          apelido: createdUser.apelido,
          date: finalDateString[2] + '/' + finalDateString[1] + '/' + finalDateString[0],
          documentType: createdUser.documentType,
          email: createdUser.email,
          documentNumber: createdUser.documentNumber,
          ciudad: createdUser.ciudad,
          codigo_mun_tu: createdUser.codigo_mun_tu,
          codigo_gera: createdUser.codigo_gera,
          codigo_dept_tu: createdUser.codigo_dept_tu,
          celular: createdUser.celular,
          direccion: createdUser.direccion,
          complemento: createdUser.complemento,
          localNumber: createdUser.localNumber,
          localType: createdUser.localType ? createdUser.localType : '',
          dateRegister: dateRegister,
          idReferencia: createdUser.idReferencia ? createdUser.idReferencia : '',
          ipUser: ipUser
        }

        try {
          await fetch('/.netlify/functions/createEquifax', {
            method: 'POST',
            body: JSON.stringify(body)
          })
            .then((res) => res.text())
            .then(async (data) => {
              const resulting = JSON.parse(data)

              const resultingStatus = resulting.clientImplementationStatus === 'completed'

              const updatedUser = {
                ...createdUser,
                UUID: resultingStatus ? resulting.clientImplementationUUID : null,
                statusEquifax: resultingStatus ? true : false,
                log: JSON.stringify(resulting)
              }

              const { _id } = updatedUser
              delete updatedUser._id

              await axios.put('/.netlify/functions/updateLink', {
                id: _id,
                data: updatedUser
              })
            })
        } catch (err) {
          console.error('fetch failed', err)
        }
      } catch (err) {
        addDataLayer(values, JSON.stringify(err))
        setStep(2)
        setLoading(false)
        setConfirmation(false)
        console.error('fetch failed', err)
      }
    }
  }

  const getUserIp = async () => {
    try {
      const res = await fetch('https://api.ipify.org?format=json')
      const userIp = await res.json()
      setIP(userIp.ip)
      return userIp.ip
    } catch (err) {
      console.error(err)
    }
  }

  const getDate = () => {
    const date = new Date()
    const setYear = date.getFullYear()
    const setMonth = date.getMonth()
    const setDate = date.getDate()
    const setHours = date.getHours()
    const setMin = date.getMinutes()

    const resultDate = `${setYear}/${
      setMonth === 1 ? setMonth : setMonth + 1
    }/${setDate} ${setHours}:${setMin}`

    setDateRegister(resultDate)
  }

  const handleChange = (event) => {
    event.persist()
    setValues((values) => ({ ...values, [event.target.name]: event.target.value }))
  }

  const handleSelectChange = async (value) => {
    setValues((values) => ({ ...values, ciudad: value }))
  }

  const handleChecked1 = () => setChecked1(!checked1)
  const handleChecked2 = () => setChecked2(!checked2)
  const handleChecked3 = () => setChecked3(!checked3)

  return {
    handleSelectChange,
    handleChange,
    handleSubmit,
    handleStep,
    handleStepReturn,
    handleChecked1,
    checked1,
    handleChecked2,
    checked2,
    handleChecked3,
    checked3,
    values,
    errors,
    errorsStep1,
    step,
    setConfirmation,
    confirmation,
    loading
  }
}

export default useForm
